import { useSelector } from 'react-redux';
import { getTransformEntities } from 'js/reducers/selectors';
import { ACCESS_ROLES, ReusableTransformType } from '@nexla/@types';
import { TransformType } from 'new/components/ReusableTransform/types';

type ReusableTransformTypeMap = Record<number, ReusableTransformType>;

type compareArg = { created_at: string | number | Date };
const compareFNDate = (a: compareArg, b: compareArg) =>
  new Date(b.created_at) < new Date(a.created_at) ? -1 : 1;

function getReusableTransformsByRole(
  role: ACCESS_ROLES,
  data: ReusableTransformTypeMap,
  resourceType: TransformType,
) {
  if (!role || !data) return [];
  return Object.values(data)
    .sort(compareFNDate)
    .filter((i) => i.access_roles.includes(role) && resourceType === i.output_type && !i.public);
}

function getPublicReusableTransform(data: ReusableTransformTypeMap, resourceType: TransformType) {
  if (!data) return [];
  return Object.values(data)
    .sort(compareFNDate)
    .filter((i) => i.public && resourceType === i.output_type);
}

export function useAttributeTransforms(resourceType: TransformType) {
  const data = useSelector<any>(getTransformEntities) as ReusableTransformTypeMap;
  if (!data) return [];

  return Object.values(data)
    .sort(compareFNDate)
    .filter((i) => resourceType === i.output_type);
}
